export default __webpack_public_path__ + "static/media/ninja-cow.2b6d3c83.png";